import React, { useState, useRef } from 'react';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/bg7.jpg";
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
const useStyles = makeStyles(styles);
var md5 = require('md5');


export default function LoginPage(props) {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");

  const [name, setName] = React.useState();
  const [password, setPassword] = React.useState();
  const [passwordRepeat, setPasswordRepeat] = React.useState();

  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  var onEnterPress = (e) => {
    if(e.key === 'Enter') {
      e.preventDefault();
      CompleteRegistration();
    }
  }
  const { ...rest } = props;
  if (localStorage.getItem('registered') == 'true')
    props.history.push("/Profile");
    function Go() {
      swal("در حال انتقال", {
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttons: false,
        allowOutsideClick: false
      })
  
      Axios.post(Config.api + "Product/Buy/Start", {
        productIds: ["5ffcde0ea50731301591cf3c"],
        redirectUrl: "Expositions/ZarinPal/Verify",
      },
        {
          headers: {
            apikey: Config.apikey,
            Authorization: "Bearer " + localStorage.getItem('token')
  
          }
        }).then((result) => {
         // return swal("رویداد از 25 بهمن آغاز خواهد شد، لطفا در زمان مقرر مراجعه فرمایید.")
          window.location.href = "/Expositions/Main/";
        }).catch(err => {
          console.log(err)
          if (err && err.response && err.response.status && err.response.status === 401) {
            localStorage.removeItem('token');
            props.history.push("/SignIn");
          }
          else if (err && err.response && err.response.status && err.response.status === 422)
            swal("اطلاعات ارسالی نادرست است.");
          else if (err && err.response && err.response.status && err.response.status === 409) {
            swal("اطلاعات ارسالی نادرست است.");
          }
          else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
            swal(err.response.data.message.pr);
          else swal("خطایی رخ داده است.")
        })
  
    }
  var CompleteRegistration = () => {
    if (password != passwordRepeat) {
      return swal("کلمه های عبور یکی نیستند.")
    }
    if(!name){
      return swal("نام و نام خانوداگی را وارد کنید.")
    }
    if(!password){
      return swal("کلمه عبور را وارد کنید.")
    }
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      name: name,
      password: md5(password)
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')

        }
      }).then(async (result) => {
        localStorage.setItem('registered', true);
        props.history.push("/Profile");

       /* swal({
          title: "ثبت نام موفق!",
          text: "نمایشگاه ایران ایتکس هم اکنون در حال برگزاری ست.",
          icon: "success",
          
          buttons: {
            expo: {
              text: "ورود  به نمایشگاه",
              value: 0,
              visible: true,
              className: "",
              closeModal: true
            },
            event: {
              text: "رویدادهای جانبی",
              value: 1,
              visible: true,
              className: "",
              closeModal: true,
            },
            profile: {
              text: "پروفایل",
              value: 2,
              visible: true,
              className: "",
              closeModal: true,
            }
          }
        }).then((e)=>{
          if(e==0){
            Go();
          }else if(e==1){
            props.history.push("/Expositions");
          }else{
              props.history.push("/Profile");
          }
        })*/
      }).catch((err) => {
        console.log(err)
        if (err&&err.response&&err.response.status&&err.response.status === 401){
          localStorage.removeItem('token');
          props.history.push("/SignIn");
        }
        else if (err&&err.response&&err.response.status&&err.response.status === 422)
          swal("اطلاعات ارسالی نادرست است.");
        else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")

      })
  }
  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h5>تکمیل ثبت نام</h5>
                  </CardHeader>
                  <CardBody>
                    <CustomInput
                      labelText="نام و نام خانوادگی"
                      id="name"
                      onKeyPress={onEnterPress}
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: (e) => { setName(e.target.value) },
                        type: "text",
                        endAdornment: (
                          <InputAdornment position="end">
                            <PersonOutlineOutlinedIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                    />
                    <CustomInput
                      labelText="کلمه عبور"
                      id="password"
                      onKeyPress={onEnterPress}
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: (e) => { setPassword(e.target.value) },
                        type: "password",
                        endAdornment: (
                          <InputAdornment position="end">
                            <VpnKeyOutlinedIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                    />
                    <CustomInput
                      labelText="تکرار کلمه عبور"
                      id="repeatPassword"
                      onKeyPress={onEnterPress}
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: (e) => { setPasswordRepeat(e.target.value) },
                        type: "password",
                        endAdornment: (
                          <InputAdornment position="end">
                            <VpnKeyOutlinedIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                    />

                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <div className={classes.extra}>

                    </div>
                    <Button onClick={CompleteRegistration} color="success">
                      <ArrowBackIosIcon />
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
